export default __webpack_public_path__ + "static/right-top-pixi-5ee0ce025861af127388713896890864.png";